import Vue from 'vue';
import store from '../store';
import { EventBus } from '../api/eventbus';

export default class Achievement {
    /**
     * @param options
     */
    constructor(
        {
            id = '',
            isAchieved = false,
            name = '',
            description = null,
            factor = 0,
            type = 'time',
            shop = null,
            branches = null,
            bonusType = '',
            balance = null,
            bonusFactor = 1,
            shopID = null,
            faClass = null,
            icon = null,
            iconOverlay = null,
            date = '',
            shopName = ''
        } = {}) {
        this.id = id;
        this.isAchieved = isAchieved;
        this.name = name;
        this.description = description;
        this.factor = factor;
        this.type = type; // time/profit/general
        this.shop = shop; // shop id (LemonadeStand; PaperDelivery etc)
        this.branches = branches; // number of built branches that was/is necessary to achieve this
        this.faClass = faClass;
        this.icon = icon;
        this.iconOverlay = iconOverlay;
        this.balance = balance;
        this.date = date;
        this.shopName = shopName;
        this.bonusType = bonusType;
        this.bonusFactor = bonusFactor;
        this.shopID = shopID;
    }

    /**
     * @returns {*}
     */
    getDescription() {
        let baseDescription = '';
        if (this.description !== null) {
            return Vue.i18n.translate(this.description);
        }
        switch (this.type) {
        case 'shopAmount':
            baseDescription = Vue.i18n.translate('ACHIEVEMENT_BRANCHES', {
                branches: this.branches
            });
            break;
        case 'balance':
            baseDescription = Vue.i18n.translate('ACHIEVEMENT_BALANCE', { balance: this.balance });
            break;
        default:
            baseDescription = '';
            break;
        }
        return baseDescription + this.getBonusDescription();
    }

    /**
     * @returns {*}
     */
    getBonusDescription() {
        switch (this.bonusType) {
        case 'decreaseProductionTime':
            return Vue.i18n.translate('UPGRADE_DECREASE_PRODUCTION_TIME', {
                shop:   Vue.i18n.translate(this.shop),
                factor: this.bonusFactor
            });
        case 'increaseEarnings':
            return Vue.i18n.translate('UPGRADE_INCREASE_EARNINGS', {
                shop:   Vue.i18n.translate(this.shop),
                factor: this.bonusFactor
            });
        default:
            return '';
        }
    }

    /**
     * @param loaded
     */
    merge(loaded) {
        this.isAchieved = loaded.isAchieved;
        this.date = loaded.date;
        if (Object.prototype.hasOwnProperty.call(loaded, 'achieve')) {
            // do not achieve "fake" achievements
            loaded.achieve(false);
        }
    }

    /**
     * @param {boolean} sendMessage
     */
    achieve(sendMessage = true) { //this achievement was achieved
        // set to achieved so it will not be compared against future shop amount changes
        this.isAchieved = true;
        if (this.date === '') {
            // only set current date if it was not loaded
            this.date = Date.now();
        }
        if (sendMessage) {
            if (this.bonusType === 'increaseEarnings') {
                //increase bonus factor for all shops
                store.getters.allShops.forEach(shop => {
                    store.commit('MODIFY_SHOP_ATTRIBUTE', {
                        shop,
                        attribute: 'earningsMultiplier',
                        value:     shop.earningsMultiplier * this.bonusFactor
                    });
                    // shop.setEarningsMultiplier(shop.earningsMultiplier * this.bonusFactor);
                });
            }
            EventBus.$emit('addAchievementMessage', this);
            EventBus.$emit('playSound', 'applause');
        }
    }
}
